import { render, staticRenderFns } from "./wxLaunchWeapp.vue?vue&type=template&id=37029701&scoped=true&"
import script from "./wxLaunchWeapp.vue?vue&type=script&lang=js&"
export * from "./wxLaunchWeapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37029701",
  null
  
)

export default component.exports